<header class="atmos-page__header">
  <h1 class="atmos-page__title">Data error</h1>
</header>

<div class="atmos-page__intro">
  <p class="atmos-paragraph">Oops. You shouldn't be here. Loading the data failed. Please report this issue.</p>
</div>
